module.exports = __webpack_public_path__ + "img/tim-alt.7c9e8d94.png";